// extracted by mini-css-extract-plugin
export default {"sortIcon":"app-core-components-datatables-components-TableHeaderCell-module__sort-icon"};